export default __webpack_public_path__ + "static/media/Standard33.fd4187dc.png";